import RevolutCardField from './revolut-card-field.js'
import { revolutSettings, PAYMENT_METHODS, i18n } from '../../utils'
import { BlockLabel } from '../components/index.js'

const settings = revolutSettings(PAYMENT_METHODS.REVOLUT_CARD)

const RevolutGatewayBlock = {
  name: PAYMENT_METHODS.REVOLUT_CARD,
  label: <BlockLabel settings={settings} />,
  content: <RevolutCardField />,
  edit: <p>{i18n('Revolut Gateway is not available in editor mode')}</p>,
  ariaLabel: i18n('Revolut Card`s Gateway'),
  canMakePayment: () => settings.can_make_payment,
  supports: {
    features: ['products'],
    showSavedCards: true,
    showSaveOption: true,
  },
}
export default RevolutGatewayBlock
